import { PayloadAction } from '@reduxjs/toolkit';

import { ActionTypes } from './userConfig';
import { UserState } from './userInterface';

const initialState: UserState = {
};
const reducer = (state: UserState, action: PayloadAction<any>): UserState => {
    const { type, payload } = action;
    switch (type) {
        case ActionTypes.UPDATE_USER_ERROR:
            return {
                ...state,
                error: payload
            };
        case ActionTypes.UPDATE_CURRENT_APP_USER:
            return {
                ...state,
                currentAppUser: payload
            };
        case ActionTypes.UPDATE_USERS_DISPLAY_INFO:
            return {
                ...state,
                usersDisplayInfo: payload
            };
        default:
            return { ...initialState, ...state };
    }
};

export default reducer;
